export enum StatusCountry {
  Unvisited,
  Visited,
  ToVisit,
  Common,
}
